import { render, staticRenderFns } from "./login-recover.vue?vue&type=template&id=4f50fa02&scoped=true&"
import script from "./login-recover.vue?vue&type=script&lang=js&"
export * from "./login-recover.vue?vue&type=script&lang=js&"
import style0 from "./login-recover.vue?vue&type=style&index=0&id=4f50fa02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f50fa02",
  null
  
)

export default component.exports